<template>
	<BACK title="找回密码" :history="history"></BACK>
	<div class="forgetpswBox">
		<div class="forgetName">手机号</div>

		<div class="forgetpswDiv phonediv">
			<input type="text" class="forgetpswInput phone" v-model="mobile" placeholder="请输入您的认证手机" />
			<img class="inputDel"  @click="delInput('mobile')" src="@/assets/images/close_hui.png"/>
		</div>
		<div class="forgetpswDiv phoneCodeDiv">
			<input type="text" class="forgetpswInput phoneCode" v-model="smscode" placeholder="请输入短信验证码" />
			<img class="inputDel"  @click="delInput('smscode')" src="@/assets/images/close_hui.png"/>
			<van-button class="codeBtn"  @click="getPhoneCode" v-preventReClick="1500">{{codeDes}}</van-button>
		</div>
		<div class="forgetName">需6-16位，至少包含数字、字母及下划线的2种</div>
		<div class="forgetpswDiv">
			<input type="password" class="forgetpswInput psw" v-model="password" placeholder="请输入您的新密码" />
			<img class="inputDel"  @click="delInput('password')" src="@/assets/images/close_hui.png"/>
		</div>
		<div class="forgetpswDiv comfirmDiv">
			<input type="password" class="forgetpswInput comfirmpsw" v-model="password2" placeholder="请再次输入密码" />
			<img class="inputDel"  @click="delInput('password2')" src="@/assets/images/close_hui.png"/>
		</div>
		<van-button class="qdBtn" @click="comfirmfun" v-preventReClick="1500">确定</van-button>
	</div>
	<!--底部菜单-->
	<MENUE current='login'></MENUE>
</template>

<script>
	import {
		defineComponent
	} from 'vue';
	import BACK from '@/components/back/back.vue'
	import request from '@/service/request'
	import {Field,Toast,Button} from "vant"
	import MENUE from '@/components/menue/menue.vue';
	
	export default defineComponent({
		name: 'phoneLogin',
		components: {
			BACK,
			[Button.name]:Button,
			MENUE
		},
		mounted() {
			document.querySelector("body").setAttribute("style",
				"background: linear-gradient(0deg, #EDEFEB, #EDEFEB);");
		},
		unmounted() {
			document.querySelector("body").setAttribute("style",
				"background: linear-gradient(#95C5B5, #64A4A4) no-repeat;");
		},
		data(){
			return{
				codeDes:"获取验证码",
				mobile:'',
				smscode:'',
				password:'',
				password2:''
			}
		},
		created(){
			this.history=this.$route.query.history;
		},
		methods:{
			//获取验证码
			getPhoneCode() {
				if(this.codeDes!="获取验证码") return;
				if(!this.mobile){
					Toast("请输入手机号");
					return;
				}
				var phoneReg=/^(1[0123456789]{10})$/;
				if(phoneReg.test(this.mobile)){
					request.apiAxios({
						method: 'post',
						url: request.CODEOTHER,
						data: {
							mobile:this.mobile
						}
					}).then((res) => {
						if(res.status){
							var len=300;
							Toast.success("发送成功");
							this.timeDes(len);
						}else{
							Toast(res.message)
						}
						
					}).catch((err) => {
						console.log(err);
					})
				}else{
					Toast("请输入正确的手机号码");
				}
			},
			timeDes(len){
				if(len<=0){
					this.codeDes="获取验证码"
				}else{
					console.log(len);
					this.timer=setTimeout(()=>{
						len--;
						this.codeDes=len+'s';
						this.timeDes(len)
					},1000)
					
				}
			},
			comfirmfun(){
				//var regex =/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?,.]+)$)^[\w~!@#$%^&*?,.]{6,16}$/;
				var regex = /^(?!(\d+|[a-z]+|_+|(?!([\da-z]+|[\d_]+|[a-z_]+)$)[\da-z_]+)$)([\da-z]|[\d_]|[a-z_]){6,16}$/;
				if(!this.mobile||!this.smscode||!this.password||!this.password2){
					Toast("请完善信息！")
					return;
				}
				var phoneReg=/^(1[0123456789]{10})$/;
				if(!phoneReg.test(this.mobile)){
					Toast("请输入正确的手机号");
					return;
				}
				if(this.password.length<6||this.password.length>16||!regex.test(this.password)){
					Toast("需6-16位，至少包含数字、字母及标点符号的2种！");
					return;
				}
				if(this.password!==this.password2){
					Toast("两次密码不一致！");
					return;
				}
				request.apiAxios({
					method: 'post',
					url: request.FINDPWD,
					data: {
						mobile:this.mobile,
						password:this.password,
						smscode:this.smscode						
					}
				}).then((res) => {
					if(res.status){
						console.log(res,'修改成功！');
						// localStorage.setItem('token',res.data.token);
						// localStorage.setItem('userInfo',JSON.stringify(res.data));
						// this.$store.dispatch('setToken',res.token);
						window.localStorage.removeItem('token');
						this.$router.replace('/pswLogin');
					}else{
						Toast(res.message);
					}						
				}).catch((err) => {
					console.log(err);						
				})			
				
			},
			delInput(name){
				this[name]="";
			}
		},
		beforeUnmount() {
		  clearInterval(this.timer);
		}
	});
</script>

<style lang="less" scoped="scoped">
	.forgetpswBox {
		padding: 0.17rem 0.42rem;
		.phonediv{
			margin-bottom:0.6rem;
		}
		.forgetName{
			color:#20636C;
			font-size:0.3rem;
			padding:0.15rem 0;
		}
		.codeBtn{
			width: 2.22rem;
			height: 0.9rem;
			background: #73D1C7;
			border-radius: 0.14rem;
			flex:none;
			line-height:0.9rem;
		}
		.comfirmDiv{
			margin-bottom:0.36rem;
		}
	}

	.forgetpswDiv {
		height: 0.9rem;
		background: #FFFEFE;
		border-radius: 0.14rem;
		margin-bottom: 0.04rem;
		display:flex;
		padding-left:0.2rem;
		position:relative;
		input{flex:auto;border:0;}
		.inputDel{
			width: 0.52rem;
			height: 0.52rem;
			padding:0.13rem;
			position:absolute;
			top:0.2rem;
			right:0.16rem;
		}
		&.phoneCodeDiv{
			.inputDel{
				right:2.38rem;
			}
		}
	}
</style>
